import moment from 'moment'
import Button from '../ui/Button'

function DayAgendaView({ date, events, onSelectEvent, onSelectSlot }) {
    const dayEvents = (events || [])
        .filter((e) => {
            const start = moment(e.start)
            const end = moment(e.end)
            return start.isSame(date, 'day') || end.isSame(date, 'day') || (start.isBefore(date, 'day') && end.isAfter(date, 'day'))
        })
        .sort((a, b) => new Date(a.start) - new Date(b.start))

    const handleAddEvent = () => {
        const start = moment(date).hour(9).minute(0).second(0).toDate()
        const end = moment(date).hour(10).minute(0).second(0).toDate()
        onSelectSlot({ start, end, action: 'click' })
    }

    return (
        <div className="h-full overflow-y-auto p-4 sm:p-6">
            <div className="mx-auto max-w-2xl">
                <div className="mb-4 flex justify-end">
                    <Button variant="secondary" className="text-xs px-3 py-1.5" onClick={handleAddEvent}>+ Add event</Button>
                </div>

                {dayEvents.length === 0 ? (
                    <p className="font-mono text-sm text-zinc-500">No events today.</p>
                ) : (
                    <div className="relative border-l-2 border-black dark:border-white pl-6">
                        {dayEvents.map((event) => (
                            <button
                                key={event._id}
                                onClick={() => onSelectEvent(event)}
                                className="group relative mb-5 block w-full text-left last:mb-0"
                            >
                                <span
                                    className="absolute -left-[31px] top-1.5 h-3 w-3 border-2 border-black dark:border-white"
                                    style={{ backgroundColor: event.category?.color || '#FF5F1F' }}
                                />
                                <div className="border-2 border-black dark:border-white bg-white dark:bg-zinc-950 p-3 shadow-brutal-sm transition-shadow group-hover:shadow-brutal-hover">
                                    <span className="font-mono text-xs font-bold uppercase text-zinc-500">
                                        {event.allDay ? 'All day' : moment(event.start).format('h:mm A')}
                                        {!event.allDay && ` – ${moment(event.end).format('h:mm A')}`}
                                    </span>
                                    <p className="mt-1 font-serif text-lg font-semibold text-black dark:text-white">{event.title}</p>
                                    {event.location && <p className="mt-0.5 text-sm text-zinc-500">{event.location}</p>}
                                </div>
                            </button>
                        ))}
                    </div>
                )}
            </div>
        </div>
    )
}

DayAgendaView.range = (date) => [date]
DayAgendaView.navigate = (date, action) => {
    switch (action) {
        case 'PREV':
            return moment(date).subtract(1, 'day').toDate()
        case 'NEXT':
            return moment(date).add(1, 'day').toDate()
        default:
            return date
    }
}
DayAgendaView.title = (date) => moment(date).format('dddd, MMMM D, YYYY')

export default DayAgendaView
